



import React, {useEffect, useState} from 'react';
import moment from 'moment';
import axios from 'axios';
import NavBar from '../../Components/NavBar/NavBar';
// import "../../Components/HeroSection/HeroSection.css"
import { Link } from 'react-router-dom';
import "./Home.css"
import FeaturedCourses from '../../Components/FeaturedCourses/FeaturedCourses';
import CMSNews from '../../Components/CMSNews/CMSNews';
import Faqs from '../../Components/FAQs/FAQs';
import Footer from '../../Components/Footer/Footer';
import useAuth from '../../Components/Hooks/UseAuth';
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import { fab,faFacebook, faTwitter,faInstagram,faYoutube, faLinkedin, faArrowDown, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import {faHeart,faPhone,faLocationPin,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'
import ScrollToTop from '../../Components/ScrollTop/ScroolTop';

import BeatLoader from "react-spinners/SyncLoader";
import PropagateLoader  from "react-spinners/HashLoader";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';








function Home({courseSel}) { 

    // const [btnOne,SetBtnOne] = useState(true)
    // const [btnTwo,SetBtntwo] = useState(false)
    // const [btnThree,SetBtnThree] = useState(true)
    // const [btnFour,SetBtnFour] = useState(true)
    // Initialize Toastify in your main component or App component
    // toast.configure();
    const [file, setFile] = useState()
    const [fileSec, setFileSec] = useState()
    const [selectedFileType, setSelectedFileType] = useState('passport');
    const [selectedFileTypeSec, setSelectedFileTypeSec] = useState('academic');
    const [courses, setCourses] = useState();
    const [Application, setApplication] = useState();
    const [TXNData, setTXNData] = useState();
    const [accBalance, setAccBalance] = useState();

    const [activeBtn, setActiveBtn] = useState(courseSel?.item ? 5 : 0); // Set the default active button to the first one
    

    // const {auth,setAuth} = useAuth()

    // State to manage the selected option
    const [selectedOption, setSelectedOption] = useState('');
    // const [selectedOption, setSelectedOption] = useState('');

    // Function to handle changes in the dropdown
    const handleDropdownChange = (event) => {
        setSelectedOption(event.target.value);

        // console.log("change handler",event.target.value)
    };

    const [loginState, setLogin] = useState(true); 
    const [register, setRegister] = useState(false);
    const [Branch, setBranch] = useState("");
    const [Phone, setPhone] = useState("");
    const [DOB, setDOB] = useState("");
    const [NRC, setNRC] = useState("");
    const [AccNo, setAccNo] = useState("");
    const [LoadingSec, setLoadingSec] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [Msg, setMsg] = useState("");
    const [currentCourse, setcurrentCourse] = useState(courseSel?.item ? courseSel?.item : {});
    // const [currentIntake, setCurrentIntake] = useState();
    const [successMsg, setSuccessMsg] = useState(false);
    const [dropState,setDropState] = useState(false)
    // const userRef = useRef();
    // const errRef = useRef();
    const [OrgName, setOrgName] = useState("");
    const [pay, setPay] = useState(false);
    const [Intakes, setIntakes] = useState([]);
    

    const [currentIntake, setCurrentIntake] = useState(Intakes[0]?.StartDate);
    const [currentIntakeID, setCurrentIntakeID] = useState(Intakes[0]?.IntakeID);
    const [forgotPwdState, setForgotPwdStaten] = useState(false); 
    const [sucessRecovery, setSucessRecovery] = useState(false); 
    const [costsumVar, setCostsum] = useState(); 
    const [DepositVar, setDeposit] = useState(); 

  
   
   
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('')

    let costsum = 0;
    var WalletSum = 0;
    var expenditure = 0;
    var expenditure = 0;
    var Deposits = 0;
    // console.log("dagadahghah",costsum)

    const {auth,setAuth} = useAuth()

    const [isVisible, setIsVisible] = useState(false);

        const handleClose = () => {
            // console.log("Told to close")
            setIsVisible(false);
        };

   
    //

    // const handleSubmit = () => {
    //     const response = axios.post("unuilus.com",{

    //     })
    // }

    // const HandleFile = (e) =>{
    //     setFile(e.target.files[0])
    // }


    
    // const HandleUpload = (e) =>{
        
    //     const formdata = new FormData();
    //     formdata.append('image',file);
    //     axios.post(process.env.REACT_APP_BASE_URL+'/upload',formdata)
    //     .then(
    //         // res => console.log(res)
    //      res =>{  if(res.data.status = "Success"){

    //                     console.log("ops succesful")
    //                 }else{

                        
    //                     console.log("Failed!")

    //                 }
    //     }
            
    //     )
    //     .catch(err => console.log(err))
    // }

    const HandleFile = (e) => {
      
        const selectedFile = e.target.files[0];
        if (selectedFile?.size > 5242880) { // 5MB in bytes
            toast.error("File size should be less than 5MB");
            //alert("File size should be less than 5MB");
            return;
        }else{
            setFile(selectedFile);
        }
       
    }
    const HandleFileSec = (e) => {
      
        const selectedFileSec = e.target.files[0];
        if (selectedFileSec?.size > 5242880) { // 5MB in bytes
            toast.error("File size should be less than 5MB");
            //alert("File size should be less than 5MB");
            return;
        }else{
            setFileSec(selectedFileSec);
        }
       
    }

    // process.env.REACT_APP_BASEURL

    const handleFileTypeChange = (e) => {
        setSelectedFileType(e.target.value);
    }
    const handleFileTypeChangeSec = (e) => {
        setSelectedFileTypeSec(e.target.value);
    }


    const HandleUpload = () => {
        return new Promise((resolve, reject) => {
            // Check if a file is selected
            if (!file) {
                //window.alert("Kindly attach the required files");
                toast.error("Kindly attach the required files!");
                reject("No file selected for upload.");
                return; // Exit the function early if no file is present
            }
    
            const formdata = new FormData();
            formdata.append('image', file);
            formdata.append('fileType', selectedFileType);
    
            // Append the UserID to the URL directly
            const uploadURL = `${process.env.REACT_APP_BASEURL}/upload?UserID=${auth?.UserID}`;
    
            axios.post(uploadURL, formdata)
                .then(res => {
                    if (res.data.status === "Success") {
                        // toast.success("Upload successful!");
                        //window.alert("Upload successful!");
                        resolve();
                    } else {
                        //window.alert("Upload failed!");
                        toast.error("Upload failed!");
                        reject("Upload failed.");
                    }
                })
                .catch(err => {
                    //window.alert("Error during upload!");
                    toast.error("Error during upload!");
                    console.log(err);
                    reject(err);
                });
        });
    };
    
  
    // // before file checker
    // const HandleUpload = () => {
    //     return new Promise((resolve, reject) => {
    //         const formdata = new FormData();
    //         formdata.append('image', file);
    //        // formdata.append('file', file);

    //         formdata.append('fileType', selectedFileType);
    
    //         // Append the UserID to the URL directly
    //         const uploadURL = `${process.env.REACT_APP_BASEURL}/upload?UserID=${auth?.UserID}`;
    
    //         axios.post(uploadURL, formdata)
    //             .then(res => {
    //                 if (res.data.status === "Success") {
    //                    // console.log("Upload successful");
    //                     resolve();
    //                 } else {
    //                     console.log("Failed!");
    //                     reject();
    //                 }
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //                 reject();
    //             });
    //     });
    // }
    // const HandleUpload = () => {
    //     return new Promise((resolve, reject) => {
    //         const formData = new FormData();
    //         formData.append('file', file);
    //         formData.append('fileType', selectedFileType);

    //         // Append the UserID to the URL directly
    //         const uploadURL = `${process.env.REACT_APP_BASEURL}/upload?UserID=${auth.UserID}`;

    //         axios.post(uploadURL, formData)
    //             .then(res => {
    //                 if (res.data.status === "Success") {
    //                     console.log("Upload successful");
    //                     resolve();
    //                 } else {
    //                     console.log("Failed!");
    //                     reject();
    //                 }
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //                 reject();
    //             });
    //     });
    // };
    // const HandleUploadSec = () => {
    //     return new Promise((resolve, reject) => {
    //         const formdata = new FormData();
    //         const fileKey = selectedFileTypeSec === 'pdf' ? 'pdf' : 'image';
    //         formdata.append(fileKey, fileSec);
    //         formdata.append('fileType', selectedFileTypeSec);
    
    //         const uploadURL = `${process.env.REACT_APP_BASEURL}/upload?UserID=${auth?.UserID}`;
    
    //         axios.post(uploadURL, formdata)
    //             .then(res => {
    //                 if (res.data.status === "Success") {
    //                     console.log("Upload successful");
    //                     resolve();
    //                 } else {
    //                     console.log("Failed!");
    //                     reject();
    //                 }
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //                 reject();
    //             });
    //     });
    // }
    
   
    const HandleUploadSec = () => {
        return new Promise((resolve, reject) => {
            // Check if a file is selected
            if (!fileSec) {
                // window.alert("Kindly attach the required files");
                toast.error("Kindly attach the required files!");
                reject("No file selected for upload.");
                return; // Exit the function early if no file is present
            }
    
            const formdata = new FormData();
            formdata.append('image', fileSec);
            formdata.append('fileType', selectedFileTypeSec);
    
            // Append the UserID to the URL directly
            const uploadURL = `${process.env.REACT_APP_BASEURL}/upload?UserID=${auth?.UserID}`;
    
            axios.post(uploadURL, formdata)
                .then(res => {
                    if (res.data.status === "Success") {
                        //window.alert("Upload successful!");
                        // toast.success("Upload successful!");
                        resolve();
                    } else {
                        //window.alert("Upload failed!");
                        toast.error("Upload failed!");
                        reject("Upload failed.");
                    }
                })
                .catch(err => {
                    //window.alert("Error during upload!");
                    toast.error("Error during upload!");
                    console.log(err);
                    reject(err);
                });
        });
    };
    
    

    // const HandleUpload = () => {
    //     return new Promise((resolve, reject) => {
    //         const formdata = new FormData();
    //         formdata.append('image', file);
    //         formdata.append('fileType', selectedFileType);
    
    //         axios.post(`${process.env.REACT_APP_BASEURL}/upload`, formdata)
    //             .then(res => {
    //                 if (res.data.status === "Success") {
    //                     console.log("Upload successful");
    //                     resolve();
    //                 } else {
    //                     console.log("Failed!");
    //                     reject();
    //                 }
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //                 reject();
    //             });
    //     });
    // }
    

    // const HandleUpload = (e) => {
    //     const formdata = new FormData();
    //     formdata.append('image', file);
    //     formdata.append('fileType', selectedFileType);

    //     axios.post(`${process.env.REACT_APP_BASEURL}/upload`, formdata)
    //         .then(res => {
    //             if (res.data.status === "Success") {
    //                 console.log("Upload successful");
    //             } else {
    //                 console.log("Failed!");
    //             }
    //         })
    //         .catch(err => console.log(err));
    // }

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     HandleUpload();

    //     // Add your existing submission logic here
    //     console.log("Form submitted");
    // }


    
  


     const HandleDrop = () =>{
        // console.log("dropstate",dropState)
        setDropState(true)
        // console.log("dropstate",dropState)
     }
     const HandleSelect = (selectedIntake) =>{
       // console.log("currentIntake",currentIntake)
        // setCurrentIntake(selectedIntake)
        // setDropState(false)
        // console.log("currentIntake",currentIntake)
     }

    const HandleApplyView = (e,item) =>{

        // console.log("in handle applicaitn view")
        // console.log("item here",item)
        e.preventDefault();
        setcurrentCourse(item)
        setCurrentIntakeID(Intakes[0]?.IntakeID);
        setActiveBtn(5)
    }

    // if(courseSel?.item){
    //     HandleApplyView((courseSel?.item))
    
    // }


    async function handleSubmit(e) { 
        e.preventDefault(); 
        setLoading(true);
        setSuccessMsg(false);
        setErrorMsg(false);
    
        if (selectedOption === "" || selectedOption === "Gender") {
            toast.error("Please select an intake!");
            // alert("Please select an intake!");
            setLoading(false);
            return;
        }
    
        try {
            // Wait for the file upload to complete
            await HandleUpload();
    
            // Wait for the file upload to complete
            await HandleUploadSec();
    
            // Proceed with form submission after file upload
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/api/courses/`, { 
                method: "POST",
                headers: { 
                    "content-type": "application/json",
                    'Access-Control-Allow-Credentials': true
                }, 
                body: JSON.stringify({
                    NRC: auth.NRC,
                    FName: auth.FName,
                    LName: auth.LName,
                    Email: auth.Email,
                    IntakeID: selectedOption,
                    UserID: auth.UserID,
                    Cost: currentCourse?.Cost,
                    CourseName: currentCourse?.CourseName,
                    Cost: currentCourse?.Cost,
                }),
            });
    
            const data = await response.json();
    
            if (data.status === 'Ok') {
                
                
                toast.success("Application successful!");
                setLoading(false);
                setActiveBtn(2);
                setSuccessMsg(true);
                setMsg(data.msg);
                setIsVisible(true);
                setActiveBtn(1);
                handleAuthForm();        
    
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BASEURL}/api/Application`, {
                        params: {
                            Org: auth?.UserID
                        }
                    });
    
                    if (response && response?.status === 200) { 
                        setApplication(response?.data?.AppData);
                        setTXNData(response?.data?.fndData);
                        setLoading(false);
                        CalculateFund(response?.data?.AppData, response?.data?.fndData);
                        
                    }
                } catch (e) {
                    console.log(e);
                }   
            } else {
                toast.error("You have already applied for this course");
                setLoading(false);
                setMsg(data.msg);
                setErrorMsg(true);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            setMsg("File upload failed!");
            setErrorMsg(true);
        }
    }
    


    // async function handleSubmit(e,item) { 
    //      console.log("item selected",selectedOption)

    //     e.preventDefault(); 
    //     setLoading(true);
    //     setSuccessMsg(false);
    //     setErrorMsg(false);
    //     HandleUpload()
        


    //     // console.log("item selected",selectedOption)

    //     if((selectedOption == "") || (selectedOption == "Gender") ){
    //         alert("Please select an intake!");
               
    //     } else{

    //         // console.log("been clicked in selectedOption",selectedOption)
    //         const response = await fetch(process.env.REACT_APP_BASEURL+"/api/courses/",{ 
            
    //         method : "POST",
    //         headers: { 
    //         "content-type" : "application/json",
    //         'Access-Control-Allow-Credentials': true
    //         }, 
    
    
            
           
    //        //  credentials: 'include'
    //        //  ,
    //         body: JSON.stringify({
    
    //             // req.body.UserID,
    //             // req.body.NRC,
    //             // req.body.FName,
    //             // req.body.LName,
    //             // req.body.Email,
    //             // new Date(),
    //             // req.body.IntakeID,
    //             // "Pending",
    //             NRC:  auth.NRC,
    //             FName:  auth.FName,
    //             LName:  auth.LName,
    //             Email:  auth.Email,
    //             // IntakeID : currentIntakeID,
    //             IntakeID : selectedOption,
    //             UserID : auth.UserID,
    //             Cost: currentCourse?.Cost,
    //             Cour: currentCourse?.Cost,
    //             Cost: currentCourse?.Cost,
    
      
    //         }),
            
           
            
            
           
    //         }) 
    //     //    console.log("been clicked in apply")
    //         const data = await response.json();
    //         // console.log(data);
           
    //         // if(data==undefined){
            
    //         // }
    
    //         // {
    //         //     "msg" : "Application Sucessful!",
    //         //      "status" : "Ok"
    //         //    });
      
           
    //         if(data.status == 'Ok'){
    //         // navigate("/login");
    //         setLoading(false);
    //         setActiveBtn(2)
    //         setSuccessMsg(true)
    //         setMsg(data.msg)
    //         setIsVisible(true)
    //         setActiveBtn(1)
            
    //         handleAuthForm()        
                
    //             //HANDLE COURSE REFRESH AFTER APPLICATION
    //             try{      
     
    //                 const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/Application', {
    //                    // signal: controller.signal,
    //                    params: {
           
    //                        Org: auth?.UserID
    //                        // org: 'value2',
    //                        // mgtLvl: 'value2',
    //                      }
    //                }
                    
    //                 )
        
                    
    //                 // console.log("am in query params")
        
    //                 // if (courses){
        
    //                   if(response && response?.status == 200){ 
        
    //                     //   console.log("Application",response.data)
    //                       setApplication(response?.data?.AppData);
    //                       setTXNData(response?.data?.fndData);
    //                       setLoading(false)
       
    //                   CalculateFund(response?.data?.AppData,response?.data?.fndData)
       
    //                     //   console.log("costvar",costsumVar)
       
                          
       
                          
        
    //                   } else{
    //                    //  setCourses(coursesType)
    //                     // console.log("Error req Application")
    //                   }
                     
        
    //               }catch(e){
                    
    //               }   
                
                
    
    
    
    //         }else{
           
    //         setLoading(false);
    //         setMsg(data.msg)
    //         setErrorMsg(true);
    //         }

    //     }
       
       

      






    //     }



        async function handleSubmitSec(e,item) { 
            e.preventDefault(); 
            // setLoading(true);
            // setSuccessMsg(false);
            // setErrorMsg(false);
            if(item?.Cost>accBalance){
                toast.error("Insufficient funds. Proceed to payment page")
                
                //alert("Insufficient funds. Proceed to payment page");
                
            }else{  

                setLoading(true)

                const response = await fetch(process.env.REACT_APP_BASEURL+"/api/register/",{ 
            
                    method : "POST",
                    headers: { 
                    "content-type" : "application/json",
                    'Access-Control-Allow-Credentials': true
                    }, 
                   
                   //  credentials: 'include'
                   //  ,
                    body: JSON.stringify({
            
                        // req.body.UserID,
                        // req.body.NRC,
                        // req.body.FName,
                        // req.body.LName,
                        // req.body.Email,
                        // new Date(),
                        // req.body.IntakeID,
                        // "Pending",
                        // NRC:  auth.NRC,
                        // FName:  auth.FName,
                        // LName:  auth.LName,
                        // Email:  auth.Email,
                        // IntakeID : currentIntakeID,
                        // IntakeID : selectedOption,
                        UserID : auth.UserID,
                        IntakeID: item?.IntakeID,
                        Cost: item?.Cost,
                        CourseCode: item?.CourseCode,
                        CourseName: item?.CourseName,
                        // Cost: currentCourse?.Cost,
            
              
                    }),
                    
                   
                    
                    
                   
                    }) 
                //    console.log("been clicked in apply")
                    const data = await response.json();
                    // console.log(data);
                   
                    // if(data==undefined){
                    
                    // }
            
                    // {
                    //     "msg" : "Application Sucessful!",
                    //      "status" : "Ok"
                    //    });
              
                   
                    if(data?.status == 'Ok'){           
                        try{      
 
                            const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/Application', {
                               // signal: controller.signal,
                               params: {
                   
                                   Org: auth?.UserID
                                   // org: 'value2',
                                   // mgtLvl: 'value2',
                                 }
                           }
                            
                            )
                
                            
                            // console.log("am in query params")
                
                            // if (courses){
                
                              if(response && response?.status == 200){ 
                
                                //   console.log("Application",response.data)
                                  setApplication(response?.data?.AppData);
                                  setTXNData(response?.data?.fndData);
                                  setLoading(false)
               
                              CalculateFund(response?.data?.AppData,response?.data?.fndData)
               
                               //    await Application.map((item,key)=>{
               
                               //     costsum = costsum+ item?.Cost
                               //     console.log("cost",costsum)
               
                               //    })
                               //   await TXNData.map((item,key)=>{
               
                               //     Deposits = Deposits + item?.Amount
                               //     console.log("Deposits",Deposits)
               
                               //    })
               
                               //   var wait = await setCostsum(costsum);
                               //   var waitSec = await setDeposit(Deposits);
                                //   console.log("costvar",costsumVar)
               
                                  
               
                                  
                
                              } else{
                               //  setCourses(coursesType)
                                // console.log("Error req Application")
                              }
                             
                
                          }catch(e){
                            // setCourses(coursesType)
                            //     console.log("courses",courses)
                          }    

                    }else{
                    // alert("Operation Failed")
                    setLoading(false);
                    // setMsg(data.msg)
                    // setErrorMsg(true);
                    }
            

            }
    
    
            // console.log("item",item)
           
            // const response = await fetch("https://superagentback.onrender.com/api/register",{ 
            // const response = await fetch("http://localhost:2001/api/authregister",{ 
           //  const response = await fetch("https://unilus.com/Org",{ 
    
        //    console.log("been clicked in selectedOption",selectedOption)
           
    
    
        }


const handleAuthForm = () =>{

    setLogin(!loginState); 
    setRegister(!register);
    setForgotPwdStaten(false)
    
    }

        

    const handleBtnClick = (index) => {
      setActiveBtn(index);
    }; 

//    const{auth,setAuth} =  useAuth()

    useEffect(()=>{

        // console.log("Hi there auth data",auth)
        // console.log("courseSel",courseSel)
    },[])

    useEffect(()=>{
        async function getCourses (){ 
             
           try{      
 
             const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/courses/')
 
 
            //  console.log("am in useffect",response)
 
             // if (courses){
 
               if(response && response?.status == 200){ 
 
                //    console.log("Courses",response.data)
                   setCourses(response?.data);
 
               } else{
                 setCourses(coursesType)
                //  console.log("courses",courses)
               }
              
             // }
 
           }catch(e){
             setCourses(coursesType)
                //  console.log("courses",courses)
                 // console.log("catch error",e)
           }
              
 
        }
        
         //  Async response = axios.get('http://localhost:8800/Books')
 
         getCourses()
          
 
     },[])


   // Function to calculate the sum of all object costs with a specific status
const calculateTotalCost = (array, status) => {
    // Use reduce method to iterate over the array and accumulate the sum of costs
    return array.reduce((totalCost, currentItem) => {
      // Check if the status of the current item matches the specified status
      if (currentItem.Status === status) {
        // Add the cost of the current object to the total cost
        return totalCost + currentItem.Cost;
      } else {
        // If status doesn't match, return the current totalCost unchanged
        return totalCost;
      }
    }, 0); // Start with a total cost of 0
  };

     // Function to calculate the sum of all object costs
const calculateTotalDeposits = (array) => {
    // Use reduce method to iterate over the array and accumulate the sum of costs
    return array.reduce((totalCost, currentItem) => {
      // Add the cost of the current object to the total cost
      return totalCost + currentItem.Amount;
    }, 0); // Start with a total cost of 0
  };


     const CalculateFund = (apps,funds) =>{
        // console.log("I am in calculate apps",apps)
        // console.log("I am in calculate funds2",funds)

        // console.log("Total cost:", calculateTotalCost(apps,"Registered"));
        // console.log("Total deposits:", calculateTotalDeposits(funds));
        setAccBalance(calculateTotalDeposits(funds)-calculateTotalCost(apps,"Registered"))
     }

    useEffect(()=>{
        async function getCourses (){ 
             
           try{      
 
             const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/Application', {
                // signal: controller.signal,
                params: {
    
                    Org: auth?.UserID
                    // org: 'value2',
                    // mgtLvl: 'value2',
                  }
            }
             
             )
 
         
 
               if(response && response?.status == 200){ 
 
                   console.log("Application",response.data)
                   setApplication(response?.data?.AppData);
                 //  console.log("Applications",response?.data?.AppData)
                   setTXNData(response?.data?.fndData);

               CalculateFund(response?.data?.AppData,response?.data?.fndData)


                   
 
               } else{
                //  setCourses(coursesType)
                //  console.log("Error req Application")
               }
              
 
           }catch(e){
             setCourses(coursesType)
                //  console.log("courses",courses)
           }
              
        }
 
         getCourses()
          
 
     },[])

     useEffect(()=>{
        async function getIntakes(){ 
             
           try{      
 
             const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/Intake')
 
 
            //  console.log("am in useffect")
 
             // if (courses){
 
               if(response && response?.status == 200){ 
 
                //    console.log("Intakes",response.data)
                   setIntakes(response?.data);
 
               } else{
                //  setCourses(coursesType)
                //  console.log("Error req Application")
               }
              
 
           }catch(e){
            //  setCourses(coursesType)
                //  console.log("Error in intakes")
           }
              
        }
 
        getIntakes()
          
 
     },[])
 
 

    const coursesType = [   

        {
            "Title " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration" : "6 weeks",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Price" : "1750",
            "Image" :""
        },
        {
            "Title " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration" : "6 weeks",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Price" : "1750",
            "Image" :""
        },
        {
            "Title " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration" : "6 weeks",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Price" : "1750",
            "Image" :""
        },
        {
            "Title " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration" : "6 weeks",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Price" : "1750",
            "Image" :""
        },
        {
            "Title " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration" : "6 weeks",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Price" : "1750",
            "Image" :""
        },
        {
            "Title " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration" : "6 weeks",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Price" : "1750",
            "Image" :""
        },
     
    ]
 
 

  return <>
        <div className='HomeDashCoverWhole'> 

                <ScrollToTop/>

                <NavBar/>   
                <div className='IgnatiusDrop'>  

                {isVisible && (
        <div className="confirmation-container">
          <div className="overlay"></div>
          <div className={`confirmation-card ${isVisible ? 'visible' : 'hidden'}`}>
            <div className="card">
              <div className="close-button" onClick={handleClose}>
                   Close[<FontAwesomeIcon className="fontawesomIconsCLose" icon={faTimes} /> ]
              </div>
              <div className="content">
                <h2>Application submitted</h2>
                {/* <p className="status">Almost Done!</p> */}
                {/* <p>Thank you for applying! Your application has been successfully submitted.</p> */}

                <div className="next-steps">
                  <h3>Next Steps</h3>
                  <p>Your enrollment is pending finalization after review.</p>
                  {/* <p>Your enrollment is pending finalization and requires payment confirmation to be completed.</p> */}
                  {/* <button className="complete-payment-btn"><Link className='LinkItems' to={`https://www.unilus.ac.zm/bank.php`}>Complete Payment Now</Link></button> */}


                  {/* {pay?  <div className="close-buttonSec" onClick={handleClose}>
                       
                    </div>:
                             <button onClick={()=>{setPay(true)}} className="complete-payment-btn">Complete Payment Now</button>

                    }
                 
                  {pay && <>    
                      <div>
                         <h2>Banks</h2>
                           <p> Zanaco Bill muster</p>
                           <h3><b>Steps</b></h3>
                           <p>1. Go to the nearest Zanaco Billmuster authorized Branch or booth</p>
                           <p>2. Your student ID (<b>{`${auth?.UserID}`}</b> ) is all that is required to process the payment</p>
                          

                        <h2>Mobile Money</h2>
                           <p> Airtel money Bill muster</p>
                           <h3><b>Steps</b></h3>
                           <p>1. Dial *115#</p>
                           <p>2. Select Option 4 (Make Pyament)</p>
                           <p>3. Select Option 7 (School fees)</p>
                           <p>4. Select Option 3 (Zanaco Billmuster)</p>
                           <p>5. Select Option 1 (University)</p>
                           <p>6. Select Option 4 (Unilus)</p>
                           <p>7. Select Option 1 (Unilus)</p>
                           <p>8.Enter your student number: <b>{`${auth?.UserID}`}</b></p>
                           <br/>
                           <div className="close-button" onClick={handleClose}> Close[<FontAwesomeIcon className="fontawesomIconsCLose" icon={faTimes} /> ] </div>
                  
                      </div>
                  
                  </>}
                  <p>Secure your spot now! Full Payment must be completed before the start date.</p> */}
                </div>

                <div className="assistance">
                  <p>
                    Have questions or need assistance? Reach out to our support team at{' '}
                    <span className="email">info@unilus.ac.zm</span>.
                  </p>
                  <br/>
                  {/* {pay &&  <div className="close-buttonSec" onClick={handleClose}>
                        <button  className="complete-payment-btn">Close Menu [X]</button>
                    </div>

                    } */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

                </div>
                
                <div className='HomeDashCoverContainer'>    
                    <div className='HomeDashCover'>

                        
                            <div className='taglineHomeDashCover'>
                                        <h2>My Dashboard</h2>
                            </div>
                            <div className='HomeDashCoverStudentNumber'>
                                 <b><p>{`STUDENT ID: ${auth?.UserID}`}</p></b> 
                            </div>

                              <div className='BtnSection'>
                                    <div
                                        className={activeBtn === 0 ? 'BtndItemActive' : 'BtndItem'}
                                        onClick={() => handleBtnClick(0)}
                                    >
                                        <h3>Finances</h3>
                                    </div>
                                    <div
                                        className={activeBtn === 1 ? 'BtndItemActive' : 'BtndItem'}
                                        onClick={() => handleBtnClick(1)}
                                    >
                                        <h3>My Current Courses</h3>
                                    </div>
                                    <div
                                        className={activeBtn === 2 ? 'BtndItemActive' : 'BtndItem'}
                                        onClick={() => handleBtnClick(2)}
                                    >
                                        <h3>My past courses</h3>
                                    </div>
                                    <div
                                        className={activeBtn === 3 ? 'BtndItemActive' : 'BtndItem'}
                                        onClick={() => handleBtnClick(3)}
                                    >
                                        <h3>Apply for course</h3>
                                    </div>
                                    </div>

                          

                            <div className='courseContentSection'>   


                                {activeBtn == 0 &&   
                                    <div className='resptCourse'>
                                        <div className='WalletCover'> 
                                               <p><b>Account Balance: </b>{`ZMK ${accBalance}`}</p>
                                        </div>
                                        <div className='txnHeading'> 
                                               <h2>INVOICE(S)</h2>
                                        </div>
                                       
                                            <table> 
                                              
                                                            <thead>
                                                                <tr>
                                                                    <td><b></b></td>
                                                                    <td><h3>Course</h3></td>
                                                                    <td><b>Date</b></td>
                                                                    <td><b>Status</b></td>
                                                                    <td><b>Cost</b></td>
                                                                   
                                                                    {/* <td><b>Action</b></td> */}
                                                                    
                                                                   
                                                                </tr>
                                                            </thead> 
                                                            <tbody> 

                                                            {
                                        Application?.length > 0
                                        ? Application.sort((a, b) => new Date(b?.CreationDate) - new Date(a?.CreationDate)) // Sort by CreationDate in descending order
                                        .map((item, index) => {
                                            // ?Application.map((item,index)=>{
                                                return(<>   

                                                    <tr>    
                                                                     <td>
                                                                        {/* <div className='applicationStatusCoverNo'>   */}
                                                                             <p>{`${index+1}.`}</p>
                                                                        {/* </div> */}
                                                                     </td>
                                                                    <td>
                                                                        {/* <div className='applicationStatusCoverName'>     */}
                                                                            <p>{item?.CourseName}</p>
                                                                        {/* </div> */}
                                                                    </td>
                                                                    <td>    
                                                                        <div className='applicationStatusCoverappDate'>   
                                                                           <p>{moment(item?.CreationDate).format('YYYY-MM-DD')}</p>

                                                                            {/* <p>{String(item?.CreationDate).substring(0,10)}</p> */}
                                                                        </div>

                                                                    </td>
                                                                    <td>
                                                                                    <div className='applicationStatusCoverStatus'> 
                                                                                        {item?.ReviewStatus === "Pending" ? (
                                                                                        <button className="button-pending">Under Review</button>
                                                                                        ) : item?.ReviewStatus === "Rejected" ? (
                                                                                        <button className="button-rejected">Rejected</button>
                                                                                        ) : item?.ReviewStatus === "Incomplete" ? (
                                                                                        <button className="button-incomplete">Incomplete</button>
                                                                                        ) : item?.ReviewStatus === "Accepted" ? (
                                                                                        <>
                                                                                            {item?.Status === "Pending" ? (
                                                                                            <>
                                                                                                {Loading ? (
                                                                                                <BeatLoader size={6} color="#36d7b7" className='beatloader' />
                                                                                                ) : (
                                                                                                <p>
                                                                                                    <button className='CourseRegBtn' onClick={(e) => handleSubmitSec(e, item)}>
                                                                                                    Click to Register
                                                                                                    <ToastContainer /> 
                                                                                                    </button>
                                                                                                </p>
                                                                                                )}
                                                                                            </>
                                                                                            ) : (
                                                                                            <button className="button-settled">Registered</button>
                                                                                            )}
                                                                                        </>
                                                                                        ) : null}
                                                                                    </div>  
                                                                                            {/*                                                                             
                                                                            {
                                                                                item?.Status == "Pending"?
                                                                                  
                                                                                   <>{ Loading ?  <BeatLoader  size={6} color="#36d7b7" className='beatloader' />  : <p><button className='CourseRegBtn' onClick={(e)=>{handleSubmitSec(e,item)}}>Click to Register</button>  </p> }</> :
                                                                                    <button>Settled</button>
                                                                                
                                                                             } */}

                                                                                    </td>

                                                                    <td>    
                                                                        <div className='applicationStatusCoverappDate'>   
                                                                            <p>{`zmk ${String(item?.Cost)}`}</p>
                                                                        </div>

                                                                    </td>
                                                                   

                                                    </tr>
                                                      
                                                </>)
                                                
                                            }) 
                                            
                                            : <b><p>You currently do not have any Debits</p></b> 
                                        }   

<tr>    
                                                                     <td>
                                                                     
                                                                             <p><b>Total</b></p>
                                                                       
                                                                     </td>
                                                                    <td>
                                                                     
                                                                            {/* <p>{item?.CourseName}</p> */}
                                                                      
                                                                    </td>
                                                                    <td>    
                                                                        {/* <div className='applicationStatusCoverappDate'>   
                                                                            <p>{String(item?.CreationDate).substring(0,10)}</p>
                                                                        </div> */}

                                                                    </td>
                                                                    <td>    
                                                                        {/* <div className='applicationStatusCoverappDate'>   
                                                                            <p>{String(item?.Cost)}</p>
                                                                        </div> */}

                                                                    </td>
                                                               
                                                                    <td>
                                                                        <div className='applicationStatusCoverStatus'>  
                                                                            <p><b>{Application && `ZMK ${calculateTotalCost(Application,"Registered")}`} </b></p>
                                                                          
                                                                        </div>
                                                                    </td>
                                                                 

                                                    </tr>

                                                             
                                </tbody>
                                   
                                           

                            </table>    
                            <div className='txnHeadingSec'> 
                                               <h2>CREDITS</h2>
                                        </div>

                            <table>
                                                            <thead>
                                                                <tr>
                                                                    <td><b></b></td>
                                                                    <td><b>Status</b></td>
                                                                    <td><b>Date</b></td>
                                                                    <td><b>Description</b></td>
                                                                    <td><b>Amount</b></td>
                                                                   
                                                                    {/* <td><b>Action</b></td> */}
                                                                    
                                                                   
                                                                </tr>
                                                            </thead> 
                                                            <tbody> 

                                                            {
                                        TXNData?.length > 0
                                            ?TXNData.map((item,index)=>{
                                                return(<>   

                                                    <tr>    
                                                                     <td>
                                                                        {/* <div className='applicationStatusCoverNo'>   */}
                                                                             <p>{`${index+1}.`}</p>
                                                                        {/* </div> */}
                                                                     </td>
                                                                    <td>
                                                                        {/* <div className='applicationStatusCoverName'>     */}
                                                                            <p>{item?.Status}</p>
                                                                        {/* </div> */}
                                                                    </td>
                                                                    <td>    
                                                                        <div className='applicationStatusCoverappDate'>   
                                                                            <p>{String(item?.TransactionDate).substring(0,10)}</p>
                                                                        </div>

                                                                    </td>
                                                                    <td>
                                                                        <div className='applicationStatusCoverStatus'>  
                                                                            {/* <p><b>Credit</b></p> */}
                                                                            <p>{item?.Error}</p>
                                                                        </div>
                                                                    </td>
                                                                    <td>    
                                                                        <div className='applicationStatusCoverappDate'>   
                                                                            <p>{`zmk ${String(item?.Amount)}`}</p>
                                                                        </div>

                                                                    </td>
                                                                   

                                                    </tr>
                                                      
                                                </>)
                                                
                                            }) 
                                            
                                            : <b><p>You currently do not have any Credits</p></b> 
                                        }   

<tr>    
                                                                     <td>
                                                                     
                                                                             <p><b>Total</b></p>
                                                                       
                                                                     </td>
                                                                    <td>
                                                                     
                                                                            {/* <p>{item?.CourseName}</p> */}
                                                                      
                                                                    </td>
                                                                    <td>    
                                                                        {/* <div className='applicationStatusCoverappDate'>   
                                                                            <p>{String(item?.CreationDate).substring(0,10)}</p>
                                                                        </div> */}

                                                                    </td>
                                                                    <td>    
                                                                        {/* <div className='applicationStatusCoverappDate'>   
                                                                            <p>{String(item?.Cost)}</p>
                                                                        </div> */}

                                                                    </td>
                                                               
                                                                    <td>
                                                                        <div className='applicationStatusCoverStatus'>  
                                                                            <p><b>{TXNData && `ZMK ${calculateTotalDeposits(TXNData)}`} </b></p>
                                                                          
                                                                        </div>
                                                                    </td>
                                                                 

                                                    </tr>

                                                             
                                </tbody>
                                   
                                           

                            </table>
                                        
                                    </div>
                                }
                                {activeBtn == 1 &&   
                                    <div className='resptCourse'>
                                         <ScrollToTop/>

                                         <table>
                                                            <thead>
                                                                <tr>
                                                                    <td><b></b></td>
                                                                    <td><h3>Course</h3></td>
                                                                    <td><b>Applied</b></td>
                                                                    <td><b>Start</b></td>
                                                                    <td><b>Status</b></td>
                                                                    <td><b>Action</b></td>
                                                                    
                                                                   
                                                                </tr>
                                                            </thead> 
                                                            <tbody> 

                                                            {
                                        Application?.length > 0
                                        ? Application.sort((a, b) => new Date(b?.CreationDate) - new Date(a?.CreationDate)) // Sort by CreationDate in descending order
                                        .map((item, index) => {
                                                return(<>   

                                                    <tr>    
                                                                     <td>
                                                                        {/* <div className='applicationStatusCoverNo'>   */}
                                                                             <p>{`${index+1}.`}</p>
                                                                        {/* </div> */}
                                                                     </td>
                                                                    <td>
                                                                        {/* <div className='applicationStatusCoverName'>     */}
                                                                            <p>{item?.CourseName}</p>
                                                                        {/* </div> */}
                                                                    </td>
                                                                    <td>    
                                                                        <div className='applicationStatusCoverappDate'>   
                                                                            {/* <p>{String(item?.CreationDate).substring(0,10)}</p> */}
                                                                            <p>{moment(item?.CreationDate).format('YYYY-MM-DD')}</p>
                                                                        </div>

                                                                    </td>
                                                                    <td>    
                                                                            <div className='applicationStatusCoverStart'>   
                                                                                <p>{String(item?.StartDate).substring(0,10)}</p>
                                                                            </div>

                                                                    </td>
                                                                    <td>
                                                                        <div className='applicationStatusCoverStatus'>  
                                                                            <p>{item?.Status}</p>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                                    <div className='applicationStatusCoverStatus'> 
                                                                                        {item?.ReviewStatus === "Pending" ? (
                                                                                        <button className="button-pending">Under Review</button>
                                                                                        ) : item?.ReviewStatus === "Rejected" ? (
                                                                                        <button className="button-rejected">Rejected</button>
                                                                                        ) : item?.ReviewStatus === "Incomplete" ? (
                                                                                        <button className="button-incomplete">Incomplete</button>
                                                                                        ) : item?.ReviewStatus === "Accepted" ? (
                                                                                        <>
                                                                                            {item?.Status === "Pending" ? (
                                                                                            <>
                                                                                                {Loading ? (
                                                                                                <BeatLoader size={6} color="#36d7b7" className='beatloader' />
                                                                                                ) : (
                                                                                                <p>
                                                                                                    <button className='CourseRegBtn' onClick={(e) => handleSubmitSec(e, item)}>
                                                                                                        <ToastContainer/>
                                                                                                    Click to Register
                                                                                                    </button>
                                                                                                </p>
                                                                                                )}
                                                                                            </>
                                                                                            ) : (
                                                                                            <button className="button-settled"><Link to={"https://host.unilus.app/login/index.php"}>Registered. Click to view course</Link> </button>
                                                                                            )}
                                                                                        </>
                                                                                        ) : null}
                                                                                    </div>  
                                                                                            {/*                                                                             
                                                                            {
                                                                                item?.Status == "Pending"?
                                                                                  
                                                                                   <>{ Loading ?  <BeatLoader  size={6} color="#36d7b7" className='beatloader' />  : <p><button className='CourseRegBtn' onClick={(e)=>{handleSubmitSec(e,item)}}>Click to Register</button>  </p> }</> :
                                                                                    <button>Settled</button>
                                                                                
                                                                             } */}

                                                                                    </td>                                                             {/* <td>    
                                                                    <div className={item?.Status == 'Pending' ? 'applicationStatusCoverCTA':"applicationStatusCoverCancel"}>    
                                                                             {
                                                                                item?.Status == "Pending"?
                                                                                 
                                                                                    <>{ Loading ?  <BeatLoader  size={6} color="#36d7b7" className='beatloader' />  : <p><button className='CourseRegBtn' onClick={(e)=>{handleSubmitSec(e,item)}}>Click to Register</button>  </p> }</> :
                                                                                    <button>Registered</button>
                                                                              
                                                                             } 
                                                                     
                                                                    </div>
                                                                       
                                                                    </td> */}

                                                    </tr>
                                                        {/* <div className='applicationStatusCover'>    

                                                       

                                                            <div className='applicationStatusCoverNo'>  
                                                                 <b><p>{`${index+1}.`}</p></b>
                                                            </div>
                                                            <div className='applicationStatusCoverName'>    
                                                                 <b><p>{item?.CourseName}</p></b>
                                                            </div>
                                                            <div className='applicationStatusCoverappDate'>   
                                                                <b><p>{String(item?.CreationDate).substring(0,10)}</p></b>
                                                            </div>
                                                            <div className='applicationStatusCoverStart'>   
                                                                <b><p>{String(item?.StartDate).substring(0,10)}</p></b>
                                                            </div>
                                                            <div className='applicationStatusCoverStatus'>  
                                                            <b><p>{item?.Status}</p></b>
                                                            </div>
                                                            <div className={item?.Status == 'Pending' ? 'applicationStatusCoverCTA':"applicationStatusCoverCancel"}>  
                                                                <button>Register</button>
                                                            </div>
                                                 
                                                        </div> */}
                                                </>)
                                                
                                            }) 
                                            
                                            : <b><p>You currently do not have any active courses</p></b> 
                                        }
                                                             
                                                            </tbody>
                                   
                                           

                            </table>
                                        

                                          
                                    </div>
                                }
                                {(activeBtn == 2) && (courses.length) &&
                                    <div className='resptCourse'>
                                            <b><p>You do have past enrollments or applications</p></b> 
                                    </div>
                                }
                                {(activeBtn == 2) && !(courses.length) &&
                                    <div className='resptCourse'>
                                       
                                            <b><p>Here are your past enrollments or applications</p></b> 
                                    </div>
                                }
                                {activeBtn == 3 &&   
                                <div className='resptCourse'>
                                    {courses && courses.map((item, index) => { 
                                        return (
                                            <div className='applyresContainer' key={index}> 
                                                <div className='resFirsthalf'>  
                                                    <div className='resName'><h2>{item?.CourseName}</h2></div>
                                                    <div className='resImg'>{item?.Description}</div>        
                                                </div>
                                                <div className='resSechalf'>    
                                                    <div className='resAppword'></div>
                                                    <div className='resAppCTA'>
                                                        <button onClick={(e) => {
                                                          
                                                            HandleApplyView(e,item);
                                                        }}>
                                                            {`Apply for ${item?.CourseName}`}
                                                        </button>
                                                    </div> 
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                } 





                                

                                {(activeBtn == 5) && (courses?.length) &&
                                    <div className='resptCourse'>
                                        <div className='ApplicationCardCover'>   
                                            <div className='TopHeading'>    
                                                         <h2>Application process</h2> 
                                                </div>   
                                          
                                                <div className='applicationInputCover'> 
                                                  
                                                    <div className='applicationInputTitle'> 
                                                        <h3>Course</h3>
                                                    </div>
                                                    <div className='applicationInputActual'>
                                                        <p>{currentCourse?.CourseName}</p>
                                                    </div>
                                                </div>
                                              
                                                <div className='applicationInputCover'> 
                                                  

                                                    <div className='applicationInputTitle'> 
                                                        <h3>Duration </h3>
                                                    </div>
                                                    <div className='applicationInputActual'>
                                                       <p>{`${currentCourse?.Duration_Weeks} weeks`}</p>
                                                    </div>
                                                </div>
                                                
                                                <div className='applicationInputCover'> 
                                                  

                                                    <div className='applicationInputTitle'> 
                                                        <h3>Cost</h3>
                                                    </div>
                                                    <div className='applicationInputActual'>
                                                      <p>{`ZMK ${(currentCourse?.Cost)}`}</p>
                                                    </div>
                                                </div>
                                              
                                                <div className='applicationInputCover'> 

                                                 

                                                    <div className='applicationInputTitle'> 
                                                        <h3>Intake</h3>
                                                    </div>
                                                         <div className='customdropdownCover'>
                                                    {/* <label htmlFor="dropdown">Select an option:</label> */}
                                                         <select  disabled={LoadingSec} id="dropdown" defaultValue={selectedOption} onClick={handleDropdownChange} className="customdropdown">
                                                            
                                                         
                                                           
                                                            { Intakes && Intakes.map((item,index)=>{
                                                                // console.log("Intake item",item)
                                                                return(
                                                                    <>      
                                                                     {/* checking if the selected course and coursecode in array match before map */}
                                                                    {
                                                                    (currentCourse?.CourseCode == item?.CourseCode) && 
                                                                        //   <option key={index} >{"HI"}</option>
                                                                          <option value={item?.IntakeID} onClick={()=>{console.log("intake id here")}} key={index} >{String(item?.StartDate).substring(0,10)}</option>
                                                                        //   <option value={item?.IntakeID} onClick={()=>{console.log("intake id here",item?.IntakeID)}} key={index} >{String(item?.StartDate).substring(0,10)}</option>
                                                                        //   <option value={item?.IntakeID} onClick={()=>{console.log("intake id here",item?.IntakeID)}} key={index} >{"Select an Intake"}</option>
                                                                    }
                                                                      
                                                                       
                                                                     </>
                                                                    
                                                                )
                                                            })}
                                                            
                                                        </select>

                                                        {/* <p>You selected: {selectedOption}</p> */}
                                                        </div>

                                                    {/* <div className='applicationInputActual'>    
                                                        <div onClick={HandleDrop} className='intakeDropDown'> 
                                                                <div className='Month'> 
                                                                   <p>{currentIntake}</p>
                                                                </div>
                                                                <div className='Icon'>  
                                                                   <p><FontAwesomeIcon icon={faChevronDown}/></p>
                                                                </div>
                                                                
                                                                <div className='dropItems'> 
                                                                   
                                                                { dropState && Intakes.map((dropItem,dropIndex)=>{
                                                                            return(
                                                                            <div onClick={()=>{
                                                                                HandleSelect(dropItem)
                                                                            }}   className='dropItem' key={dropIndex}> 
                                                                                    <p>{dropItem?.StartDate}</p>
                                                                            </div>)
                                                                        })
                                                                    }
                                                                </div>
                                                        </div>
                                                      
                                                    </div> */}
                                                </div>
                                                <div className='applicationInputCover'> 
                                                  

                                                  <div className='applicationInputTitle'> 
                                                      <h3>Cost</h3>
                                                  </div>
                                                  <div className='applicationInputActual'>
                                                    <p>{`ZMK ${(currentCourse?.Cost)}`}</p>
                                                  </div>
                                              </div>
                                                <div className='applicationInputCover'> 
                                                <div className='applicationInputCover'>

                                                            <div className='applicationInputTitle'>
                                                                <h3>Attach File</h3>
                                                            </div>
                                                            <div className='applicationInputActual'>
                                                                <input  disabled={LoadingSec} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={HandleFile} />
                                                                <select id="fileType" defaultValue={selectedFileType} onChange={handleFileTypeChange} className="customdropdown">
                                                                    <option value="passport">NRC/Passport</option>
                                                                    {/* <option value="academic">Academic Documents</option> */}
                                                                </select>
                                                            </div>
                                                        </div>

                                                 
                                              </div>
                                                <div className='applicationInputCover'> 
                                                <div className='applicationInputCover'>

                                                            <div className='applicationInputTitle'>
                                                                <h3>Attach File 2</h3>
                                                            </div>
                                                            <div className='applicationInputActual'>
                                                                <input disabled={LoadingSec} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={HandleFileSec} />
                                                                <select id="fileType" defaultValue={selectedFileTypeSec} onChange={handleFileTypeChangeSec} className="customdropdown">
                                                                    {/* <option value="passport">Passport</option> */}
                                                                    <option value="academic">Academic Document</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                 
                                              </div>

                                              
                                            
                                              

                                                 <div className='applicationInputCover'> 

                                                    {LoadingSec?  

                                                            <div className='beatloaderClass'> 
                                                            <PropagateLoader size={30} />
                                                            </div> :

                                                            <div onClick={handleSubmit} className='ApplicationCTA'> 
                                                            <  button>APPLY</button>
                                                            <ToastContainer/>

                                                            </div>
                                                    
                                                      }
                                                        
                                                       
                                                       
                                                        
                                                
                                              </div>
                                               
                                               
                                        </div>
                                           
                                    </div>
                                }  
                                    

                            </div>

                    </div>
                </div>
                

                <Faqs/>
                <Footer/>
                

        </div>
       
    
  </>
  
  ;
}

export default Home;